import { ReactNode } from 'react';
import { X, Minus, Square } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AIMWindowProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  onClose?: () => void;
  onMinimize?: () => void;
  showMinimize?: boolean;
  showMaximize?: boolean;
  isActive?: boolean;
}

export function AIMWindow({
  title,
  icon,
  children,
  className,
  onClose,
  onMinimize,
  showMinimize = true,
  showMaximize = false,
  isActive = true,
}: AIMWindowProps) {
  return (
    <div className={cn("aim-window flex flex-col", className)}>
      {/* Title Bar */}
      <div className={cn("aim-titlebar select-none", !isActive && "aim-titlebar-inactive")}>
        <div className="flex items-center gap-2">
          {icon && <span className="w-4 h-4 flex-shrink-0">{icon}</span>}
          <span className="truncate text-xs">{title}</span>
        </div>
        <div className="flex items-center gap-0.5">
          {showMinimize && (
            <button
              onClick={onMinimize}
              className="aim-window-button"
              aria-label="Minimize"
            >
              <Minus className="w-2.5 h-2.5" />
            </button>
          )}
          {showMaximize && (
            <button className="aim-window-button" aria-label="Maximize">
              <Square className="w-2 h-2" />
            </button>
          )}
          {onClose && (
            <button
              onClick={onClose}
              className="aim-window-button hover:bg-red-500 hover:text-white"
              aria-label="Close"
            >
              <X className="w-2.5 h-2.5" />
            </button>
          )}
        </div>
      </div>
      
      {/* Window Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {children}
      </div>
    </div>
  );
}
